export enum GoogleAutocompleteType {
  InputText,
  InputBar,
}
